import React from 'react';
import { Outlet } from 'react-router-dom';

function PublicLayout() {
  return (
    <main className="public-shell">
      <Outlet />
    </main>
  );
}

export default PublicLayout;